// Adding a new size:
//   1. Pick the button size in px (e.g. sm = 36, md = 44)
//   2. container = Tailwind size class for the button (e.g. tw-size-9 = 36px)
//   3. icon / spinner = button × 0.27, rounded to nearest Tailwind class
//   4. ringWrapper = button × 1.27 (ring is 27% larger than the button)
//   5. ringViewBox = "0 0 {ringWrapperPx} {ringWrapperPx}"
//   6. ringCenter = ringWrapperPx / 2
//   7. ringRadius = ringCenter − 2 (2px inset so the stroke doesn't clip)
//   8. ringStrokeWidth = button × 0.045
export const PREVIEW_PLAYER_SIZE_CONFIG = {
  xs: {
    container: "tw-size-7",
    icon: "tw-size-2",
    spinner: "tw-size-2",
    ringWrapper: "tw-size-9",
    ringViewBox: "0 0 36 36",
    ringCenter: 18,
    ringRadius: 16,
    ringStrokeWidth: 1.26,
  },
  sm: {
    container: "tw-size-9",
    icon: "tw-size-2.5",
    spinner: "tw-size-2.5",
    ringWrapper: "tw-size-[2.875rem]",
    ringViewBox: "0 0 46 46",
    ringCenter: 23,
    ringRadius: 21.5,
    ringStrokeWidth: 1.65,
  },
  md: {
    container: "tw-size-11",
    icon: "tw-size-3",
    spinner: "tw-size-3",
    ringWrapper: "tw-size-14",
    ringViewBox: "0 0 56 56",
    ringCenter: 28,
    ringRadius: 26,
    ringStrokeWidth: 2,
  },
} as const;

export type PreviewPlayerSize = keyof typeof PREVIEW_PLAYER_SIZE_CONFIG;
